var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-tabs"},[_c('div',{staticClass:"tabs-scroll"},[_c('div',{staticClass:"tabs-wrap"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:['tab-item', { active: index === _vm.currentIndex }],on:{"click":function($event){return _vm.changeType(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }